import React from 'react';
import PropTypes from 'prop-types';
import { Text, DateTime, Member } from 'components/common/Elements/Elements';
import { getInitialsFull } from 'utils/common';
import classes from './Messages.module.scss';

const Messages = ({ data }) => {
  return (
    <div className={classes.info}>
      <div className={classes.title}>
        <Member
          member={{
            fullName: data.userName,
            description: data.userEmail,
            initials: getInitialsFull(data.userName)
          }}
        />
        <DateTime date={data.updatedAt} time />
      </div>
      <Text type={'p'} size={4} className={classes.message}>
        {data.message}
      </Text>
    </div>
  );
};

Messages.propTypes = {
  data: PropTypes.object.isRequired
};

export default Messages;
